import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("F:/webroot/diary.ilovearomagrace.com/layouts/default.vue").then(m => m.default || m)),
  none: defineAsyncComponent(() => import("F:/webroot/diary.ilovearomagrace.com/layouts/none.vue").then(m => m.default || m))
}